// extracted by mini-css-extract-plugin
export default {"screen-container":"ScreenContainer_screen-container__17KGi","inner-panel":"ScreenContainer_inner-panel__AiDDM","inner-inner-panel":"ScreenContainer_inner-inner-panel__JJwXk"};